import React, { useCallback, useState } from "react";
import client from "@culturehq/client";
import { Button, Success } from "@culturehq/components";

import { Trans, t } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalConfirm from "components/common/ChqModalConfirm";

const ExportEvents = () => {
  const [{ error, success }, setState] = useState({ error: null, success: false });

  const handleAccept = useCallback(
    async () => {
      try {
        await client.exportEvents();
        setState({ success: true });
      } catch (caught) {
        setState({ error: caught });
      }
    },
    [setState]
  );

  return (
    <ChqModalConfirm
      accept={t("Export Events")}
      onAccept={handleAccept}
      trigger={onTrigger => {
        if (error) {
          return <ErrorMessage error={error} />;
        }

        if (success) {
          return (
            <Success>
              <Trans>Request received. An e-mail will be sent to you soon.</Trans>
            </Success>
          );
        }

        return (
          <p>
            <Button onClick={onTrigger} primary icon="ios-download-outline">
              <Trans>Export Analytics Data</Trans>
            </Button>
          </p>
        );
      }}
    >
      <Trans>
        Would you like to export these analytics? Once the list has been
        processed, an e-mail will be sent to you with your data in a .csv file.
      </Trans>
    </ChqModalConfirm>
  );
};

export default ExportEvents;
